import Vue from 'vue'
import App from './App.vue'
// import router from './routerManuaConfig'
import store from './store'
import router from './router/index'
import '../util/global' //全局
import './promissionRouter' //这里进行路由后台获取的模拟
import Cookies from 'js-cookie'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import 'element-ui/lib/theme-chalk/display.css';
import '@/style/index.scss' // global css
import VueBus from 'vue-bus'
Vue.use(VueBus)
Vue.use(ElementUI, {
    size: Cookies.get('size') || 'medium' // set element-ui default size
});
import 'font-awesome/css/font-awesome.min.css'
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})
Vue.prototype.platform = "win"
// Vue.prototype.platform = "web"
Vue.config.productionTip = false
Vue.prototype.getViewHeight = () => {
    return document.documentElement.clientHeight - 250;
}
Vue.prototype.getViewWidth = () => {
    return 540; 
}
Vue.prototype.getdocViewWidth = () => {
  var clientWidth = document.documentElement.clientWidth;
  if(clientWidth>=1920){
    return '85%'
  }
  if(clientWidth>1024&&clientWidth<=1600){
    return '95%';
  }
  if(clientWidth>600&&clientWidth<=1024){
    return '100%';
  }
  if (clientWidth < 600) {
      return '100%';
  } else {
      return 540;
  }
}
function fn2 (n) {
    let l = n.split('.')
    if (l.length === 1) {
      n = n + '.00'
    } else if (l[1].length === 1) {
      n = n + '0'
    }
    return n
  }
Vue.prototype.numformat2 = (n) => {
    n = parseFloat(n)
    if (isNaN(n)) {
      return 0.00
    } else {
      n =Number(n.toFixed(2))
      return n
    }
  }
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
